import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-treelist-currency-cell',
  template: `<span>{{ value | currency:currencyCode:'symbol':'1.2-2' }}</span>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TreelistCurrencyCellComponent {
  @Input() value: number | string;
  @Input() currencyCode: string = 'USD';
}
